module.exports = __webpack_public_path__ + "img/home_card_2.cbd7585a.webp";